import { createApp } from "vue";
import "@/normalize.css";
import "@/assets/sass/style.scss";
import App from "./App.vue";
import router from "./router";
import { FontAwesomeIcon } from "@/fontawesome";
import VCalendar from "v-calendar";
import Dialog from "@/components/Dialog.vue";
import loading from "@/lib/loading";
import store from "@/stores";
import logger, { LoggerKey } from "@/lib/logger";
import apiService, { apiServiceKey } from "./services/APIService.inject";
import VueLazyLoad from "vue3-lazyload"

// APIのURLを設定
console.log(process.env);
const baseURL = process.env.VUE_APP_API_BASE_URL;
// 認証ストア
const auth = store.authStore();
// APIサービス
const api = apiService(baseURL, auth);
// Loginサービス
const login = store.loginStore(api, auth, router);
// リソースサービス
const resource = store.resourceStore(api, auth);
//ロガーサービス
const loggerService = logger(api);

createApp(App)
  .provide(store.authStoreKey, auth)
  .provide(apiServiceKey, api)
  .provide(LoggerKey, loggerService)
  .provide(store.loginStoreKey, login)
  .provide(store.resourceStoreKey, resource)
  .use(router)
  .use(VCalendar, {})
  .use(loading)
  .use(VueLazyLoad, {})
  .component("fa", FontAwesomeIcon)
  .component("modal", Dialog)
  .mount("#app");
